import {
	FETCH_AL_PRODUCTION_BY_SMELTER,
	RESET_AL_PRODUCTION_BY_SMELTER
} from '../../actions';

export default (state = {}, action) => {
	switch (action.type) {
		case FETCH_AL_PRODUCTION_BY_SMELTER:
			return action.payload;
		case RESET_AL_PRODUCTION_BY_SMELTER:
			return {};
		default:
			return state;
	}
};
